import { render, staticRenderFns } from "./PhoneTaskState.vue?vue&type=template&id=df0df278&scoped=true"
import script from "./PhoneTaskState.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneTaskState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneTaskState.vue?vue&type=style&index=0&id=df0df278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0df278",
  null
  
)

export default component.exports